import { render, staticRenderFns } from "./Plug.vue?vue&type=template&id=fcd26da2&"
import script from "./Plug.vue?vue&type=script&lang=ts&"
export * from "./Plug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports